import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { extractLinkFromActions } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/extractLinkFromActions";
import * as animationStyles from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/__styles__/animationStyles.css";
import { getCssAlignmentValue } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/getCssAlignmentValue";
import { SDUIImageOrIconRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/ImageOrIcon/SDUIImageOrIconRenderer";
import { SDUITypographySuffixRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/__internal__/SDUITypographySuffixRenderer";
import { getCssTextAlign, getCssTextJustification } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/styles/textJustificationStyleUtils";
import { getLocaleId } from "@faire/retailer-visitor-shared/serialized-data/getLocaleId";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { ITextElement } from "@faire/web-api--source/indigofair/data/ITextElement";
import { TextDecorator } from "@faire/web-api--source/indigofair/data/TextDecorator";
import classNames from "classnames";
import React from "react";
export var SDUITypographyRenderer = function(param) {
    var textElement = param.textElement, loggingData = param.loggingData, className = param.className, componentStyle = param.componentStyle, avoidUnderLineOnHover = param.avoidUnderLineOnHover;
    // TODO: Handle logging
    var text = textElement.text, style = textElement.style, prefix_element = textElement.prefix_element, suffix_c_t_a = textElement.suffix_c_t_a, suffix_c_t_a_on_click = textElement.suffix_c_t_a_on_click;
    // TODO: Remove ternary once ITextElement.TextDecorator references type references are removed
    var typographyVariant = getSlateTypographyVariant(style === null || style === void 0 ? void 0 : style.type, [
        (style === null || style === void 0 ? void 0 : style.decorator) === ITextElement.TextDecorator.LINK ? TextDecorator.TEXT_DECORATOR_UNKNOWN : style === null || style === void 0 ? void 0 : style.decorator
    ]);
    var prefixVerticalAlignment = style === null || style === void 0 ? void 0 : style.prefix_element_vertical_alignment;
    var colorToken = getSlateColorToken(style === null || style === void 0 ? void 0 : style.color);
    var _extractLinkFromActions = extractLinkFromActions(suffix_c_t_a_on_click !== null && suffix_c_t_a_on_click !== void 0 ? suffix_c_t_a_on_click : []), link = _extractLinkFromActions.link, nonNavigationActions = _extractLinkFromActions.nonNavigationActions;
    var _getLocaleId;
    return /*#__PURE__*/ _jsxs(Row, {
        className: className,
        style: componentStyle,
        align: getCssAlignmentValue(prefixVerticalAlignment, "center"),
        justify: getCssTextJustification(style === null || style === void 0 ? void 0 : style.text_justification),
        children: [
            prefix_element ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SDUIImageOrIconRenderer, {
                        imageOrIcon: prefix_element,
                        parentColorToken: style === null || style === void 0 ? void 0 : style.color,
                        parentFontStyle: style === null || style === void 0 ? void 0 : style.type
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsxs(Typography, {
                variant: typographyVariant,
                color: colorToken,
                maxLines: style === null || style === void 0 ? void 0 : style.max_lines,
                align: getCssTextAlign(style === null || style === void 0 ? void 0 : style.text_justification),
                style: {
                    hyphens: "auto"
                },
                lang: (_getLocaleId = getLocaleId()) !== null && _getLocaleId !== void 0 ? _getLocaleId : "en",
                "data-test-id": "sdui-typography-text",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classNames(animationStyles.underlineText, avoidUnderLineOnHover ? null : animationStyles.underLineTextHoverStyle),
                        style: {
                            backgroundImage: "linear-gradient(\n              ".concat(colorToken, ",\n              ").concat(colorToken, "\n            )")
                        },
                        children: text
                    }),
                    " ",
                    suffix_c_t_a ? /*#__PURE__*/ _jsx(SDUITypographySuffixRenderer, {
                        suffixCTA: suffix_c_t_a,
                        onClickActions: nonNavigationActions,
                        link: link,
                        loggingData: loggingData,
                        color: colorToken
                    }) : null
                ]
            })
        ]
    });
};
